import React, { Component } from 'react';
import { Header } from './header.js';
import { Footer } from './footer.js';
import { CategorySelectorList } from './category-selector-rewrite';
import * as util from './util';
import './login.css';
import './product.css';
import { logBusinessActivities } from './business_activities';
import { FeeBoxXU } from './feebox-xu';
import { TextInfo, TextLine, TextField, Price, Tags, CheckBox, SubmitButton, Selection, AGBCheckBox, MultipleFileUpload } from './common-form-components';
import './document.css';

var introductoryText = '<p>Es fallen im Gesundheitswesen im Allgemeinen, im Bereich des Krankenhauses im Speziellen, viele Forderungen für Dokumente an, die oft mit hohem Aufwand erstellt werden müssen.</p><p>Im operativen Geschäft müssen für die verschiedensten Aufgaben und Anforderungen Dokumente erstellt werden. Die Anforderungen sind meist über verschiedene Abteilungen gesehen ähnlich - und doch müssen immer wieder geforderte Dokumente mühselig erstellt werden. Das Ziel dieses Segmentes des Marktplatzes ist es, eine Angebotspalette für Dokumente jeglicher Art zur Verfügung zu stellen, damit nicht alles neu erfunden werden muss. Ein vormodelliertes Dokument anzupassen macht deutlich weniger Arbeit, als eines vom blanken Blatt Papier her neu zu schreiben. Dies kann z.B. betreffen </p><p><ul> <li>Datenschutz-Regelungen und -Umsetzungspapiere</li> <li>Vorlagen</li> <li>erfolgreiche oder erfolglose Anträge (z.B. Großgeräte-Anträge)</li> <li>Leistungsverzeichnisse</li> <li>Strategiepapiere</li> <li>Verträge jeglicher Art</li> <li>SOPs</li> <li>SLAs</li> <li>Dienstanweisungen</li> <li>Personalratsvorlagen</li> <li>nützliche Links</li> <li>sinnvolles aus Ministerien, BMG</li> <li>Gesetzesvorlagen, Verordnungen</li> <li>Fragebögen</li> <li>Excel-Sheets</li> <li>Präsentationen und Vorträge</li> <li>Outplacement-Verträge</li> <li>Trennungsrechnungskonzepte</li> <li>geschickte Skripte</li> <li>sonstige</li> </ul></p> Hier können Sie die von Ihnen erstellte Dokumente anbieten. Sie können jedoch auch kostenlose Dokumente zum Herunterladen anbieten.</p> <p> <p> Eine kleine Anzahl der Felder sind mit einem "*" gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</p>';

var documentTypes = [<option key='0'>Datenschutz-Regelungen und -Umsetzungspapiere</option>,
                     <option key='1'>Vorlagen</option>,
                     <option key='2'>erfolgreiche oder erfolglose Anträge (z.B. Großgeräte-Anträge)</option>,
                     <option key='3'>Leistungsverzeichnisse</option>,
                     <option key='4'>Strategiepapiere</option>,
                     <option key='5'>Verträge jeglicher Art</option>,
                     <option key='6'>SOPs</option>,
                     <option key='7'>SLAs</option>,
                     <option key='8'>Dienstanweisungen</option>,
                     <option key='9'>Personalratsvorlagen</option>,
                     <option key='10'>nützliche Links</option>,
                     <option key='11'>sinnvolles aus Ministerien, BMG</option>,
                     <option key='12'>Gesetzesvorlagen, Verordnungen</option>,
                     <option key='13'>Fragebögen</option>,
                     <option key='14'>Excel-Sheets</option>,
                     <option key='15'>Präsentationen und Vorträge</option>,
                     <option key='16'>Outplacement-Verträge</option>,
                     <option key='17'>Trennungsrechnungskonzepte</option>,
                     <option key='18'>geschickte Skripte</option>,
                     <option key='19'>Verzeichnis</option>,
                     <option key='20'>sonstige</option>];

let faqDocument = [
];

export class CreateDocument extends Component {
  constructor(props) {
    super(props);
    this.fetchDataAndRedirect = this.fetchDataAndRedirect.bind(this);
    this.fetchDataAndRedirect();
  }

  fetchDataAndRedirect() {
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    var url = `/api/create-document`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: ''
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert(`Could not create new document!`, exception);
        console.error(`Could not create new document!`, exception);
      });
    promise.then(function (json) {
      self.props.history.replace(`/update-document/${json.id}`);
    });
  }

  render() {
    return (
      <div className="CreateDocument">
      </div>
    )
  }
}

export class UpdateDocumentWithFeebox extends Component {
  constructor(props) {
    super(props);
    this.updateFeeByPrice = this.updateFeeByPrice.bind(this);
    this.updateFeeByCategories = this.updateFeeByCategories.bind(this);
    this.countCategories = this.countCategories.bind(this);
    this.state = {
      price: 0,
      categoryCount: 1
    };
  }

  updateFeeByPrice(price) {
    this.setState({ price: price });
    return true;
  }

  updateFeeByCategories(categories) {
    this.setState({ categoryCount: this.countCategories(categories) });
    return true;
  }


  countCategories(categories) {
    // workaround: converting String to array (FIXME)
    if ((typeof categories ) === 'string') {
      categories = categories.split(",");
    }
     console.log(categories);
     var tempCats = [];
     var count = 0;
     for (let i = 0; i < 6; i++) {
      if (categories !== undefined && categories[i] !== null && categories[i] !== "" ) {
        if (!tempCats.includes(categories[i])) {
          tempCats.push(categories[i]);
          count = count+1;
        } 
      }
    }
    return count;
  }


  render() {
    return (
      <div className="UpdateDocumentWithFeebox">
        <UpdateDocument match={this.props.match} history={this.props.history} updateFeeByPrice={this.updateFeeByPrice} updateFeeByCategories={this.updateFeeByCategories} />
        {util.isCommercialUser() &&
         <FeeBoxXU type="document" price={this.state.price} categoryCount={this.state.categoryCount} feeStepConst="100" />}
      </div>
    )
  }
}

export class UpdateDocument extends Component {
  constructor(props) {
    super(props);
    this.fetchDataAndRedirect = this.fetchDataAndRedirect.bind(this);
    this.update = this.update.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.isValid = this.isValid.bind(this);
    this.checkRequiredFields = this.checkRequiredFields.bind(this);
    this.save = this.save.bind(this);

    this.state = {
      startID: 2,
      id: null,
      name: '',
      categories: '',
      aim: '',
      content: '',
      links: '',
      target: '',
      specialties: '',
      usage: '',
      review1: '',
      review2: '',
      doctype: '',
      tags: '',
      price: 0,
      pdf_files: ',,,,',
      image_files: ',,,,,,,,,',
      video_files: '',
      product_files: '',
      doc_agreement: false,
      agb_agreement: false
    };

    this.fetchDataAndRedirect();
    this.globalFormData = {};
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState !== this.state) {
      return true;
    } else {
      return false;
    }
  }

  update(slot, value) {

    if (slot === 'price' && this.props.updateFeeByPrice !== undefined) {
      this.props.updateFeeByPrice(parseInt(value, 10));
    }
    if (slot === 'categories' && this.props.updateFeeByCategories !== undefined) {
      this.props.updateFeeByCategories(value);
    }

    this.globalFormData[slot] = value;
  }

  fetchDataAndRedirect() {
    var id = this.props.match.params.id;
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    var url = `/api/create-document`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: `id=${id}`
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine Werte laden!');
        console.error(`Could retrieve document data!`, exception);
      });
    promise.then(function (json) {
      if (self.props.updateFeeByPrice !== undefined) {
        self.props.updateFeeByPrice(parseInt(json.price, 10));
      }
      if (self.props.updateFeeByCategories !== undefined) {
        self.props.updateFeeByCategories(json.categories);
      }
      self.setState({
        id: json.id,
        name: json.name,
        categories: json.categories,
        aim: json.aim,
        content: json.content,
        links: json.links,
        target: json.target,
        specialties: json.specialties,
        usage: json.usage,
        review1: json.review1,
        review2: json.review2,
        doctype: json.doctype,
        tags: json.tags,
        price: json.price,
        pdf_files: json.pdf_files,
        image_files: json.image_files,
        video_files: json.video_files,
        product_files: json.product_files,
        doc_agreement: json.doc_agreement,
        agb_agreement: json.agb_agreement,
        feeboxPrice: json.price,
      });
    })
  }



  isValid(categories) {

    if (categories === undefined)
      return false;

    if (categories === null)
      return false;

    if (categories === "")
      return false;


    if (typeof categories === 'string') {
      categories = categories.split(/,/);
    }

    var catInput = categories.map(item => parseInt(item, 10));
    for (var i = 0; i < categories.length; i++) {
      if (parseInt(catInput[i], 10) === catInput[i]) {
        return true;
      }
    }
    return false;

  }


  validateInput() {
    if (this.globalFormData['name'] === undefined) {
      if (this.state.name.length > 200) {
        alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");
        return false;
      }
    } else {
      if (this.globalFormData['name'].length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
      if (this.globalFormData['name'].length > 200) {
        alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");
        return false;
      }
    }

    return true;
  }

  checkRequiredFields() {

    if (this.globalFormData['name'] === undefined) {
      if (this.state.name.length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
    } else {
      if (this.globalFormData['name'].length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
    }



    if ((this.globalFormData['categories'] === undefined) && (!this.isValid(this.state.categories))) {
      alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");
      return false;
    }
    if (!this.isValid(this.globalFormData['categories'])) {
      alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");
      return false;
    }



    if (this.globalFormData['price'] === undefined) {
      if (this.state.price.length === 0) {
        alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");
        return false;
      }
    } else {
      if (this.globalFormData['price'].length === 0) {
        alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");
        return false;
      }
    }

    if (this.globalFormData['doc_agreement'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }

    if (this.globalFormData['doc_agreement'] === undefined) {
      if (this.state.doc_agreement !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agb_agreement'] === false) {
      alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");
      return false;
    }

    if (this.globalFormData['agb_agreement'] === undefined) {
      if (this.state.agb_agreement !== true) {
        alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");
        return false;
      }
    }

    return true;
  }

  save(announce) {
    if (announce === true) {
      if (this.checkRequiredFields() === false) {
        return;
      }
    }

    if (announce === true) {
      if (this.validateInput() === false) {
        return;
      }
    }
    var id = this.props.match.params.id;
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    var formData = new FormData();
    Object.keys(this.globalFormData).map(key => formData.append(key, self.globalFormData[key]));
    formData.append("id", this.state.id);
    if (announce === true) {
      formData.append('announce', true);
    } else {
      formData.append('announce', false);
    }
    formData.append('active', true);
    var url = `/api/update-document`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: formData
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine Werte speichern!');
        console.error(`Could not save document data!`, exception);
      });
    promise.then(function (json) {
      alert('Werte wurden gespeichert.');
      if (announce === true) {
        logBusinessActivities("Dokument wurde gespeichert, allem zugestimmt und veroeffentlicht.", id, json.categories, json.price);
      }
      self.globalFormData = {};
      if (self.props.updateFeeByPrice !== undefined) {
        self.props.updateFeeByPrice(parseInt(json.price, 10));
      }
      if (self.props.updateFeeByCategories !== undefined) {
        self.props.updateFeeByCategories(json.categories);
      }
      self.setState({
        id: json.id,
        name: json.name,
        categories: json.categories,
        aim: json.aim,
        content: json.content,
        links: json.links,
        target: json.target,
        specialties: json.specialties,
        usage: json.usage,
        review1: json.review1,
        review2: json.review2,
        doctype: json.doctype,
        tags: json.tags,
        price: json.price,
        pdf_files: json.pdf_files,
        image_files: json.image_files,
        video_files: json.video_files,
        product_files: json.product_files,
        doc_agreement: json.doc_agreement,
        agb_agreement: json.agb_agreement,
        feeboxPrice: json.price,
      });
      self.props.history.push('/product-list');
    })
  }

  render() {
    return (
      <div>
        {(util.isNonCommercialUser() || util.isCommercialUser()) &&
         <div className="Landing" id="contentId">
           <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
           <div className="ContentWithBackground">
             <div className="content" id="content">
               <div className="productHeader1">
                 Anbieten eines Dokuments
               </div>
               <div className="productHeader2">
                 Nach abgeschlossener Einstellung Ihres Angebotes bleibt
                 dieses für ein Jahr auf der Ayacandas.com zum angegebenen
                 Preis auffindbar.
                   <TextInfo content={introductoryText} />
               </div>
               <div className="productForm1 marginTop30">
                 <div className="prodInputComp">
                   <TextLine heading='Produktitel'
                             heading2=' (Was bieten Sie an?)' obligatory={true}
                             placeholder="Name des Dokuments" maxLength='200'
                             value={this.state.name} slot='name'
                             update={this.update} />
                 </div>


                 <Selection heading="Von welchem Typ ist ihr Dokument?" selectionValues={documentTypes} obligatory={true} value={this.state.doctype} slot='doctype' update={this.update} />
                 <CategorySelectorList value={this.state.categories} slot="categories" update={this.update} categoryLimit={6} />
                 {!util.isCommercialUser() &&
                  <Price heading="Preis des Dokuments in Euro"
                         subheading="85% des Netto-Preises, den Ayacandas durch den Weiterverkauf Ihres Produktes erzielt, wird Ihnen oder Ihrer Institution für das Zurverfügungstellen der Lizenz ausbezahlt."
                         obligatory={true} maxLength='9' value={this.state.price} slot='price' kostenfrei={this.state.kostenfrei} update={this.update} />}
                  {util.isCommercialUser() &&
                   <Price heading="Preis des Dokuments in Euro" obligatory={true} maxLength='6' value={this.state.price} slot='price' kostenfrei={this.state.kostenfrei} update={this.update} />}
                   <TextField heading="Beschreibung?" placeholder="Zweck des Dokumentes" value={this.state.aim} slot='aim' update={this.update} />
                   <TextField heading="Was ist der Inhalt des Dokumentes? " placeholder="Inhalt des Dokumentes" value={this.state.content} slot='content' update={this.update} />
                   <TextField heading="Gibt es einen oder mehrere Links?" placeholder="zugehörige Links" value={this.state.links} slot='links' update={this.update} />
                   <TextField heading="Welche ist die Zielgruppe des Dokuments?" placeholder="Zielgruppe des Dokumentes" value={this.state.target} slot='target' update={this.update} />
                   <TextField heading="Besondere Merkmale des Dokuments?" placeholder="Besonderheiten des Dokuments" value={this.state.specialties} slot='specialties' update={this.update} />
                   <TextField heading="Wurden die Dokumente bereits erfolgreich begutachtet? Wenn ja, von wem?" placeholder="begutachtet von..." value={this.state.review2} slot='review2' update={this.update} />
                   <TextField heading="Wurden die Dokumente beispielsweise der Deutschen Forschungsgemeinschaft (DFG) oder einer Wirtschaftsprüfungsgesellschaft vorgelegt?" placeholder="wurden vorgelegt..." value={this.state.review1} slot='review1' update={this.update} />
                   <TextField heading="Wo wurde das Dokument bereits verwendet?" placeholder="bisherige Verwendungen des Dokumentes" value={this.state.usage} slot='usage' update={this.update} />
                   <Tags heading="Stichworte, um gefunden zu werden (max. 7, durch Komma getrennt)." placeholder="Tags/Stichworte" value={this.state.tags} slot='tags' update={this.update} match={this.props.match} maxTags={7} maxLength={150} />
                   <MultipleFileUpload heading="Anhang: Dokumente, vorzugsweise als PDF-Datei (bitte nur fachliches Material)" value={this.state.pdf_files} slot="pdf_files" update={this.update} />
                   <MultipleFileUpload heading="Anhang: Beschreibende Bilder oder Screenshots" value={this.state.image_files} slot="image_files" update={this.update} />
                   <MultipleFileUpload heading="Anhang: Video, max. 5 GB" value={this.state.video_files} slot="video_files" update={this.update} />
                   <MultipleFileUpload heading="Hier haben Sie die Möglichkeit, Ihr Produkt als eine Datei hochzuladen." value={this.state.product_files} slot="product_files" update={this.update} />
                   <CheckBox obligatory={true} heading="* Erklärung" content="Ich erkläre hiermit, dass das oder die angebotenen Dokumente entweder meiner Institution oder mir selbst gehören und mir der Verkauf oder die kostenfreie Weitergabe gestattet ist." value={this.state.doc_agreement} slot='doc_agreement' update={this.update} />

                   {!util.isCommercialUser() &&
                    <AGBCheckBox obligatory={true} value={this.state.agb_agreement} slot='agb_agreement' agbUrl="/ueberlassungsvereinbarung.pdf"
                                 content1="Das hier Eingestellte bezieht sich entweder auf einen Link oder ein kostenfreies Dokument oder im Falle eines Kaufs akzeptiere ich die " fileType="Überlassungsvereinbarung" content2="." update={this.update} />}
                    {util.isCommercialUser() &&
                     <AGBCheckBox obligatory={true} value={this.state.agb_agreement} slot='agb_agreement' agbUrl="/einstellvertrag.pdf"
                                  content1="Ich habe den " fileType="Einstellvertrag" content2=" gelesen und akzeptiere diesen." update={this.update} />}


               </div>
               <SubmitButton history={this.props.history} onSubmit={this.save} />


             </div>
           </div>
           <Footer faqs={faqDocument}/>
         </div>
        }

         {!util.isNonCommercialUser() && !util.isCommercialUser() &&
          <div>Sie besitzen nicht genügend Rechte, um ein Dokument zu erstellen.</div>
         }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/document.js